import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Reset24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M17.5835 9.01034C15.9906 5.99025 12.1995 4.80665 9.1158 6.36672C6.03214 7.92678 4.82363 11.6397 6.41653 14.6598C7.75815 17.0716 9.90085 17.6225 9.90085 17.6225L9.31752 15.0064C9.21654 14.5536 9.50952 14.1063 9.97191 14.0074C10.4343 13.9085 10.891 14.1954 10.992 14.6483L11.9628 19.0021C12.0638 19.455 11.7708 19.9023 11.3084 20.0012L6.72957 20.9805C6.26718 21.0794 5.81048 20.7925 5.7095 20.3396C5.60852 19.8867 5.9015 19.4394 6.36389 19.3406L8.49787 18.8841C8.49787 18.8841 6.19032 17.9739 4.89377 15.4302C2.86644 11.5865 4.40454 6.86088 8.3292 4.87534C12.2539 2.88981 17.0789 4.3962 19.1062 8.23996C21.1336 12.0837 19.5955 16.8093 15.6708 18.7948C14.4695 19.4026 13.6259 17.94 14.8842 17.3035C17.9679 15.7434 19.1764 12.0304 17.5835 9.01034Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
